var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLnIconSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12252",
    "data-name": "Group 12252",
    transform: "translate(0.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3476",
    "data-name": "Rectangle 3476",
    width: 28,
    height: 28,
    transform: "translate(-0.095)",
    fill: "#0b66c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.836,17.139H.283V5.7H3.836Zm-1.778-13A2.068,2.068,0,1,1,4.115,2.058,2.075,2.075,0,0,1,2.058,4.136Zm15.077,13H13.589v-5.57c0-1.327-.027-3.03-1.847-3.03-1.847,0-2.13,1.442-2.13,2.934v5.666H6.062V5.7H9.47V7.257h.05A3.733,3.733,0,0,1,12.881,5.41c3.6,0,4.257,2.368,4.257,5.444v6.285Z",
    transform: "translate(5.119 5.953)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnIconSm);
export default __webpack_public_path__ + "static/media/ln-icon-sm.35711af564777c05465cb97f9eb0c032.svg";
export { ForwardRef as ReactComponent };